<div id="content" class="ion-no-padding" [ngClass]="{'loaded': (IsCompleted && CameraAvailable && !TakenPhoto)}">

    <!-- Shows our camera stream -->
    <!-- <video #video width="100%" height="100%" [hidden]="!IsCompleted"></video> -->

    <video #video width="100%" height="100%"></video>

    <div class="ui" *ngIf="IsCompleted && EnableUI && CameraAvailable">
        <ion-button title="Tirar fotografia" size="large" shape="round" color="light" (click)="TakePhoto($event)">
            <ion-icon slot="icon-only" name="ellipse-outline"></ion-icon>
        </ion-button>
    </div>

    <div class="loading" *ngIf="IsCompleted && !CameraAvailable">

        <p>Câmara indisponível, verifique as permissões da aplicação.</p>

        <ion-button (click)="CloseCamera($event)">Confirmar</ion-button>
    </div>
</div>